import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

type Props = {
  open: boolean;
  setOpen: (isOpen: boolean) => void;
  subscriptionURl: string;
};

export const Paywall: FC<Props> = ({ open, setOpen, subscriptionURl }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={setOpen} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white text-slate-800 px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-4xl sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="sm:flex sm:items-start">
              <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left w-full">
                <DialogTitle
                  as="h3"
                  className="text-2xl font-semibold text-slate-800"
                >
                  {t("paywall.title")}
                </DialogTitle>
                <hr className="mt-2 w-full border-gray-200" />
                <div className="flex flex-row mt-5">
                  <div className="w-full">
                    <div className="sm:col-span-6">
                      <div className="rounded bg-delicate-50 p-4">
                        <div className="flex">
                          <div className="shrink-0">
                            <InformationCircleIcon
                              aria-hidden="true"
                              className="size-10 text-delicate-900"
                            />
                          </div>
                          <div className="ml-3">
                            <h3 className="text-lg font-medium text-delicate-900">
                              {t("paywall.title")}
                            </h3>
                            <div className="mt-2 text-md text-slate-800">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: t("paywall.description", {
                                    interpolation: {
                                      escapeValue: false,
                                    },
                                  }),
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
              <Link
                type="button"
                to={subscriptionURl}
                className="mt-3 inline-flex w-full justify-center rounded bg-rust-50 px-3 py-2 text-sm font-semibold text-white shadow-sm ring-1 ring-inset ring-rust-300 hover:bg-rust-100 sm:mt-0 sm:w-auto"
              >
                {t("paywall.chooseOffer")}
              </Link>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};
